import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';

export const routes: Routes = [
	{ path: 'edit', component: EditProfileComponent },
	{ path: 'login', component: LoginComponent },
	{
		path: '',
		loadChildren: () =>
			import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES)
	}
];
